import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({ name: 'CmgStaticPage' })
export default class CmgStaticPage extends Vue {
  @Prop({ type: String, required: true })
  videoSrc!: string;

  @Prop({ type: String, required: true })
  mainText!: string;

  @Prop({ type: String, required: false })
  subText?: string;

  @Prop({ type: String, required: false })
  additionalSubText?: string;

  @Prop({ type: Function, required: true })
  onPrimaryButtonClick!: () => any;

  @Prop({ type: String, required: true })
  primaryButtonText!: string;

  @Prop({ type: Function, required: false })
  onSecondaryButtonClick?: () => any;

  @Prop({ type: String, required: false })
  secondaryButtonText?: string;

  get spacingClass(): string {
    if (this.onSecondaryButtonClick && this.secondaryButtonText) {
      return 'secondary-included';
    } else if (this.additionalSubText) {
      return 'additional-subtext-included';
    }
    return '';
  }
}
